import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as moment from 'moment';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    periods: BillingPeriodData[];
    errors: AlertData[];
    isLoading: boolean;
}

type BillingPeriodData = {
    BillingPeriodID: number;
    Name: string;
    StartDate: Date;
    EndDate: Date;
}

type AlertData = {
    Message: string;
    Link: string;
}

class BillingPeriods extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            periods: [],
            errors: [],
            isLoading: false
        }
    }

    public componentWillMount() {
        this.requestBillingPeriods();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Billing Periods" />
            <div className="row">
                <div className="col">
                    <h1>Billing Periods</h1>
                </div>
                {this.state.errors.length === 0 && <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={ '/invoices/period/0' }
                    >
                        Add Billing Period
                    </Link>
                </div>}
            </div>
            {this.state.isLoading && <LoadingPanel />}
            {this.state.errors.map((error, index) => {
                return <div className="alert alert-danger d-print-none" key={index}>
                    {error.Message}&nbsp;
                    {error.Link && <Link to={error.Link} className="alert-link">Fix Here</Link>}
                </div>
            })}
            { this.renderFacilitiesTable() }
        </React.Fragment>;
    }

    private renderFacilitiesTable() {
        if (this.state.errors.length > 0) {
            return null;
        }
        return <table className='table'>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                </tr>
            </thead>
            <tbody>
                {this.state.periods.map((period, index) =>
                    <tr key={ index }>
                        <td>
                            <Link to={ `/invoices/period/${ period.BillingPeriodID }` }>
                                {period.Name}
                            </Link>
                        </td>
                        <td>{moment.utc(period.StartDate).local().format("YYYY-MM-DD")}</td>
                        <td>{moment.utc(period.EndDate).local().subtract(1, 'minute').format("YYYY-MM-DD")}</td>
                    </tr>
                )}
            </tbody>
        </table>;
    }

    private requestBillingPeriods() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        if (data.FacilityID) {
            this.setState({ isLoading: true });
            fetchApi(`api/Billing/GetBillingPeriods`, data, 'POST')
                .then((periods: BillingPeriodData[]) => {
                    this.setState({ periods, isLoading: false });
                });
        } else {
            this.setState({ errors: [{ Message: 'Please select a facility first, using the dropdown above.', Link: '' }] })
        }
    }
}

export default BillingPeriods;
